/**
 * 誕生日を元に年齢を返す
 * @param birthDate 誕生日(yyyy-mm-dd)
 */
export function getAgeFromBirthDate(birthDate: string): number {


    const today = new Date();
    const birthDay = new Date(birthDate);

    //年齢
    let age = today.getFullYear() - birthDay.getFullYear();

    const thisYearBirthDate = new Date(today.getFullYear(), birthDay.getMonth() - 1, birthDay.getDate());
    if (today < thisYearBirthDate) {
        //今年まだ誕生日が来ていない
        age--;
    }
    return age;
}

export function getYYYYMMDDhhmmss():string{
    const now = new Date();
    const res = "" + now.getFullYear() + padZero(now.getMonth() + 1) + padZero(now.getDate()) + padZero(now.getHours()) + 
        padZero(now.getMinutes()) + padZero(now.getSeconds());
    return res;
}

//先頭ゼロ付加
function padZero(num: number) {
    return (num < 10 ? "0" : "") + num;
}


/**
 * 
 */
 export function getADayBefore(year: number, month: number, day: number,): Date {
    const date = new Date(year, month -1, day);
    date.setDate(date.getDate() -1)
    return  date;
}

export function getDateStr(date: Date): string{
    const month = date.getMonth() + 1;
    return date.getFullYear() + "/" + month + "/" + date.getDate();
}